import { useLocation, useNavigate } from "react-router-dom";

import { Button } from "common/components/ui/Button";
import { DialogDescription, DialogTitle } from "common/components/ui/Dialog";
import { DrawerDescription, DrawerTitle } from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import useTemplateMutations from "../../../datahooks/useTemplateMutations";

export default function DeleteTemplateContent({
  templateName,
  templateId,
  onCancel,
}: {
  templateName: string;
  templateId: string;
  onCancel: () => void;
}) {
  const isDesktop = useTwBreakpoint("lg");
  const navigate = useNavigate();
  const { search } = useLocation();

  const { deleteTemplate, isDeletingTemplate } = useTemplateMutations();

  function removeTemplate() {
    deleteTemplate({ templateId }).then(() => {
      navigate({ pathname: "..", search });
    });
  }

  const Title = isDesktop ? DialogTitle : DrawerTitle;
  const Description = isDesktop ? DialogDescription : DrawerDescription;

  return (
    <>
      <Title>
        Delete &quot;{templateName}
        &quot; template?
      </Title>
      <Description className="mb-8">
        Campaigns using this template will continue normally, but you will not
        be able to add it to new campaigns
      </Description>

      <div className="flex flex-col gap-y-2 lg:flex-row-reverse lg:gap-x-4">
        <Button
          data-cy="delete-template-button"
          variant="outline-danger"
          className="flex-1"
          onClick={removeTemplate}
          isLoading={isDeletingTemplate}
          size={isDesktop ? "md" : "lg"}
        >
          Delete
        </Button>
        <Button
          variant="secondary-black"
          className="flex-1"
          onClick={onCancel}
          disabled={isDeletingTemplate}
          size={isDesktop ? "md" : "lg"}
        >
          Cancel
        </Button>
      </div>
    </>
  );
}
